module.exports = __webpack_public_path__ + "assets/images/project/stylised-images/party-nsp.jpg?v=3620bde8";